import React, {
    useEffect,
    useRef
} from 'react';

import Accordion from '../../scripts/components/Accordion'

import * as OPTIONS from "../option-fields";

import AccountNavigation from './account-navigation';
import UpsellBlock from '../components/upsell-block';
import LogoutButton from '../components/logout-button';

const AccountHelp = () => {

    const accordionRef = useRef(null);

    useEffect(() => {
        if (!accordionRef?.current) return;

        new Accordion(accordionRef.current);
    }, [accordionRef])

    return (
        <>
            <AccountNavigation />
            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--help'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Help & FAQs</h1>

                    {OPTIONS.account.help_faqs.block?.innerHTML &&                    
                        <div ref={accordionRef} dangerouslySetInnerHTML={{__html: OPTIONS.account.help_faqs.block.innerHTML}}></div>
                    }
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.help_upsell} type="help-upsell" />
                </div>

            </div>
        </>
    );
};

export default AccountHelp;
